import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';

import { changeDateFormate } from '../../../utils/dateFormat';
import { EmployeeDimHisDetails } from '../employeeDimHisDetails/EmployeeDimHisDetails';
import { exportExcel } from './employee-dim-history-service';
import { useGetEmployeeDimensionHistoryQuery } from './employeeDimensionHistorySlice';

type employeeDimensionHistoryProps = {
    inputYear: number;
    inputMonth: number;
    agentNumber: number;
};

export const EmployeeDimensionHistory = ({
    inputYear,
    inputMonth,
    agentNumber,
}: employeeDimensionHistoryProps) => {
    const [employeeData, setEmployeeData] = useState<any>();
    const [expandedRows, setExpandedRows] = useState<any>();

    const { data: empDimHistoryData } = useGetEmployeeDimensionHistoryQuery(
        {
            employeenumber: agentNumber,
            year: inputYear,
            month: inputMonth,
        },
        { skip: !agentNumber || !inputYear || !inputMonth }
    );

    useEffect(() => {
        if (empDimHistoryData?.data?.length > 0) {
            setEmployeeData(empDimHistoryData?.data[0]);
        }
    }, [empDimHistoryData]);

    const csrDate = (rowData: any) => {
        return changeDateFormate(rowData?.csr_dt);
    };

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };

    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <EmployeeDimHisDetails employeeDimHisDetail={rowData} />
            </div>
        );
    };
    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <div className="float-end">
                    <Button
                        type="button"
                        // style={{ marginLeft: 15 }}
                        icon="pi pi-upload me-2"
                        className="btn-export"
                        onClick={() => exportExcel(employeeData, 'EmployeeHistory')}
                        data-pr-tooltip="XLS"
                    >
                        Export
                    </Button>
                </div>
            </div>
        );
    };
    const header = renderHeader();

    return (
        <div className="col-md-12">
            <div className="card border-0">
                <div className="card-body border-0">
                    <h3 style={{ fontWeight: '400' }}>Employee History</h3>
                    <hr />
                    <div>
                        <div className="row">
                            {empDimHistoryData?.data.length > 0 ? (
                                <div>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="card border-0">
                                                    <div className="card-body border-0">
                                                        <div className="row mt-2">
                                                            <div className="col-md-3">
                                                                <h6
                                                                    style={{
                                                                        fontWeight: '600',
                                                                        fontSize: '16px',
                                                                    }}
                                                                >
                                                                    Employee
                                                                </h6>
                                                                <h6
                                                                    style={{
                                                                        fontWeight: '400',
                                                                        fontSize: '16px',
                                                                    }}
                                                                >
                                                                    {employeeData?.employee}
                                                                </h6>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <h6
                                                                    style={{
                                                                        fontWeight: '600',
                                                                        fontSize: '16px',
                                                                    }}
                                                                >
                                                                    Manager Level
                                                                </h6>
                                                                <h6
                                                                    style={{
                                                                        fontWeight: '400',
                                                                        fontSize: '16px',
                                                                    }}
                                                                >
                                                                    {employeeData?.manager_level}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body p-0 align-middle text-center table">
                                        <DataTable
                                            value={employeeData?.dailyEmployeeDimension}
                                            header={header}
                                            rowExpansionTemplate={rowExpansionTemplate}
                                            expandedRows={expandedRows}
                                            onRowToggle={(e) => {
                                                setExpandedRows(e.data);
                                            }}
                                            className="scorecardPayoutCriteria"
                                            rows={5}
                                            paginator={employeeData?.dailyEmployeeDimension.length > 5}
                                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            // filters={filters}
                                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        >
                                            <Column
                                                header="Date"
                                                sortable
                                                sortField="csr_dt"
                                                body={csrDate}
                                            />
                                            <Column
                                                header="Job Title"
                                                field="job_title"
                                                headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                                                bodyStyle={{ minWidth: '15rem' }}
                                                sortable
                                                sortField="job_title"
                                            />
                                            <Column
                                                header="Employment Type"
                                                field="employment_type"
                                                headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                                                bodyStyle={{ minWidth: '15rem' }}
                                                sortable
                                                sortField="employment_type"
                                            />
                                            <Column
                                                header="Project"
                                                field="project"
                                                headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                                                bodyStyle={{ minWidth: '15rem' }}
                                                sortable
                                                sortField="project"
                                            />
                                            {/* <Column
                                                header="Site"
                                                field="site"
                                                headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                                                bodyStyle={{ minWidth: '15rem' }}
                                                sortable
                                                sortField="site"
                                            /> */}
                                            <Column
                                                header="Scorecard"
                                                field="scorecard_name"
                                                headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                                                bodyStyle={{ minWidth: '15rem' }}
                                                sortable
                                                sortField="scorecard_name"
                                            />
                                            <Column
                                                header="Project Tenure"
                                                field="proj_tenure_days"
                                                headerStyle={{ minWidth: '5rem' }}
                                                bodyStyle={{ minWidth: '5rem' }}
                                                sortable
                                                sortField="proj_tenure_days"
                                            />
                                            <Column
                                                header="Hire Tenure"
                                                field="hire_tenure_days"
                                                headerStyle={{ minWidth: '5rem' }}
                                                bodyStyle={{ minWidth: '5rem' }}
                                                sortable
                                                sortField="hire_tenure_days"
                                            />
                                            <Column
                                                key="expand"
                                                expander={allowExpansion}
                                                style={{ width: '4em', marginRight: '10px' }}
                                            />
                                        </DataTable>
                                    </div>
                                </div>
                            ) : (
                                <div className="card mt-3 ms-1 me-1 shadow bg-body rounded border-0">
                                    <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                                        <div className="row" style={{ height: '15vh' }}>
                                            <div
                                                className="col-md-12"
                                                style={{
                                                    margin: 'auto',
                                                    paddingTop: '10px',
                                                }}
                                            >
                                                <p className="align-middle">
                                                    No results found, Try selecting an associate
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
